import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../actions'
import Forms from './Forms'
import { Row, Col } from 'antd'
import Breadcrumb from './../../../shared/components/Breadcrumbreport'
import AuthorizeComponent from './../../../auth/components/AuthorizeComponent'
import { GeneralStyledContent } from '../../../../styled/common-styled'
import { Redirect } from 'react-router-dom'

class Index extends Component {
  loadFueluse = (values, loading) => {
    this.props.loadFueluse(values, loading)
  }

  loadVehicle = (vehicletypeID, loading_vehicle) => {
    this.props.loadVehicle(vehicletypeID, loading_vehicle)
  }

  loadVehicleType = () => {
    this.props.loadVehicleType()
  }

  render() {
    const {
      vehicleLists,
      vehicleTypeLists,
      fueluse,
      fueluseLoading,
    } = this.props.fueluse
    return (
      <AuthorizeComponent {...this.props} matching_name="FueluseReport">
        <GeneralStyledContent>
          <Row gutter={24}>
            <Col span={24}>
              {/* <Breadcrumb
                sub_menu="behavior"
                match={this.props.match}
                style={{ margin: '0px 0px 14px 10px' }}
              /> */}
            </Col>
          </Row>
          <Forms
            onSubmit={this.loadFueluse}
            vehicleLists={vehicleLists}
            vehicleTypeLists={vehicleTypeLists}
            fueluseLoading={fueluseLoading}
            loadVehicle={this.loadVehicle}
            loadVehicleType={this.loadVehicleType}
            auth={this.props.profile}
          />
        </GeneralStyledContent>
      </AuthorizeComponent>
    )
  }
}

const mapStateToProps = ({ fueluse, auth: { profile } }) => ({
  fueluse,
  profile,
})

const mapDispatchToProps = {
  loadFueluse: actions.loadFueluse.request,
  loadVehicle: actions.loadVehicle.request,
  loadVehicleType: actions.loadVehicleType.request,
}

export default connect(mapStateToProps, mapDispatchToProps)(Index)
